import React from 'react'

const EFFECTIVE = 'June 29, 2026'

export default function Privacy() {
  return (
    <section className="page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p className="updated">Last updated: {EFFECTIVE}</p>

        <p>
          Heard is built to be private by default. This policy explains what the App does and does not
          collect. Heard is provided by Alana .sh (“we”, “us”).
        </p>

        <h2>The short version</h2>
        <p>
          Heard does not require an account, and we do not sell your information. The books you
          read and the audio generated from them stay on your device — they are never sent to us.
          We do use privacy-conscious analytics (see “Analytics” below) to understand coarse,
          aggregate usage of the App, such as which books are opened.
        </p>

        <h2>On-device processing</h2>
        <p>
          Text-to-speech narration is generated entirely on your device. The text of the books you read
          and the audio that’s produced are never sent to us or to any third-party server. Books you
          import stay on your device.
        </p>

        <h2>Information we don’t collect</h2>
        <ul>
          <li>No name, email, or account is required to use the App.</li>
          <li>
            The actual text of the books you read, and the audio generated from them, never leave
            your device — not to us, and not to any third party.
          </li>
        </ul>

        <h2>Analytics</h2>
        <p>
          We use Firebase Analytics (a Google product) to understand coarse, aggregate usage of the
          App — for example, that a book was opened, that playback started or paused, or that a
          voice was changed. These events include the book’s ID and title (truncated) and the
          selected voice/language, but never the book’s text or any generated audio. Firebase also
          automatically collects standard technical information (such as device model, OS version,
          app version, and a randomly generated app-instance identifier) that is not tied to your
          name or any account. See{' '}
          <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noreferrer">
            Firebase’s privacy and security information
          </a>{' '}
          and{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
            Google’s privacy policy
          </a>
          .
        </p>

        <h2>Purchases</h2>
        <p>
          If you subscribe to Heard Pro, the purchase is processed by Apple, and subscription status is
          managed through our payments provider, RevenueCat. To validate your subscription, RevenueCat
          receives a randomly generated, app-specific identifier and your App Store purchase receipt. We
          do not receive your name or payment-card details. See{' '}
          <a href="https://www.revenuecat.com/privacy" target="_blank" rel="noreferrer">RevenueCat’s privacy policy</a>{' '}
          and{' '}
          <a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noreferrer">Apple’s privacy policy</a>.
        </p>

        <h2>Local storage</h2>
        <p>
          Settings (such as your chosen voice, theme, and font), your reading position, and any imported
          books are stored locally on your device. Deleting the App removes this data.
        </p>

        <h2>Children</h2>
        <p>
          Heard is not directed to children under 13 and does not knowingly collect information from
          them. The App does not collect a name, email, precise location, or any other information
          that could identify you personally, so it is suitable for general audiences.
        </p>

        <h2>Changes</h2>
        <p>
          We may update this policy from time to time. Material changes will be reflected by the “Last
          updated” date above.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about your privacy? Email hello [at] alana [dot] sh.
        </p>
      </div>
    </section>
  )
}
